export default __webpack_public_path__ + "static/handwriting-e0258bf79b6e8d698905c788172f28b7.mp4";